import styled, { keyframes } from 'styled-components';
import { COLORS } from '../../styles/variables';

const spin = keyframes`
  to { transform: rotate(360deg) }
`;

export const Spinner = styled.div`
  display: inline-block;
  width: 24px;
  height: 24px;
  border: 3px solid ${COLORS.grey70};
  border-radius: 50%;
  border-top-color: ${COLORS.white};
  animation: ${spin} 1s ease-in-out infinite;
`;

export const SubmitCTA = styled.button<{ disabled: boolean }>`
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: ${({ disabled }) => (disabled ? COLORS.grey30 : COLORS.black)};
  color: ${COLORS.white};
  font-family: Audi Type;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.003px;
  cursor: ${({ disabled }) => !disabled && 'pointer'};
`;
